<div class="titleblock">
	<ng-template [ngIf]="!isSchedaAnalitica" >
	<a data-toggle="collapse" [attr.data-target]="'#' + provenienza.id + tipoDocumento.id" aria-expanded="false"
		style="cursor: pointer !important;" aria-controls="panelcontenttemplate" class="collapsed">
		<h3 class="title1level"> {{ tipoDocumento.label + ' (' + getDocumentiByTipoDocumento().length.toString() + '/' + getQuantitaByTipoDocumento().toString()+ ')'}}
		</h3>
	</a>
</ng-template>
<ng-template [ngIf]="isSchedaAnalitica" >

		<h3 class="title1level"> {{ tipoDocumento.label + ' (' + getDocumentiByTipoDocumento().length.toString() + '/' + getQuantitaByTipoDocumento().toString()+ ')'}}
		</h3>

</ng-template>
	<div *ngIf="writable" class="data_opzioni blocco_pratica" style="top: 27px !important">
		<ul class="censimento_documenti">
			<li class="opzioni" appDropdownFocus><a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button"
					aria-haspopup="true" aria-expanded="false" style="color: white !important;">Opzioni<span
						class="glyphicon glyphicon-option-vertical"></span></a>
				<div class="dropdown-menu">
					<ul option-censimento-documenti [fascicolo]="fascicolo" [pratica]="fascicolo.praticaBase"
						[writable]="writable" [canDeleteTipoDocumento]="canDeleteTipoDocumento()"
						(onReturnOptionCensimentoDocumenti)="runMethodCensimentoDocumentiOption($event.method)">
					</ul>
				</div>
			</li>
		</ul>
	</div>
</div>
<div class="container_dati_generali" *ngIf="!isSchedaAnalitica">
	<ul id="{{provenienza.id + tipoDocumento.id}}" class="collapse" documenti_allegati_lista=""
		[documenti]="getDocumentiByTipoDocumento()" [writable]="writable" [nomeCampoId]="''" [subdoc]="true"
		[fascicolo]="fascicolo" [isCensimenti]="true" (onReturn)="onReturnUpdateCallback($event, sezione)"
		(openModal)="showUploadNewVersionModal($event)" (openModalSpostaDoc)="showMoveDocumentModal($event)"
		(openHistoryModal)="showHistoryModal($event)" (removDoc)="removeDoc($event)"
		(onOpenUpdateMetadatiModal)="showUpdateMetadatiModal($event)"></ul>
</div>